import { useMutation } from "@apollo/client"
import { CHANGE_PASSWORD_MUTATION } from "@/graphql/queries/changePassword"

interface ChangePasswordInput {
  userId: number
  passwd: string
  token: string
}

interface ChangePasswordResponse {
  UserPasswdUpdateAnon: {
    status: {
      success: boolean
      name: string
      detail: string
    }
    user: {
      Person: {
        id: number
        avatar?: string
        fullName: string
        urlAvatar?: string
        code: string
      }
    }
  }
}

interface UseChangePasswordOptions {
  onCompleted?: (data: ChangePasswordResponse) => void
  onError?: (error: any) => void
}

export function useChangePassword(options: UseChangePasswordOptions = {}) {
  const [changePasswordMutation, { loading, error }] = useMutation<
    ChangePasswordResponse,
    { UserPasswdUpdateInput: ChangePasswordInput }
  >(CHANGE_PASSWORD_MUTATION, {
    onCompleted: options.onCompleted,
    onError: options.onError,
  })

  const mutate = (input: ChangePasswordInput) => {
    return changePasswordMutation({
      variables: {
        UserPasswdUpdateInput: input,
      },
    })
  }

  return {
    mutate,
    loading,
    error,
  }
}
